import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { RoleService } from '../../services/role.service';
import { SubsidiaryService } from '../../services/subsidiary.service';

@Component({
    selector: 'app-display-role',
    templateUrl: './display-role.component.html',
    styleUrls: ['./display-role.component.css', '../../app.component.css']
})

export class DisplayRoleComponent implements OnInit {

    role: any = [];

    id: string;

    grSubs: any;
    gsSubs: any;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private roleService: RoleService,
                private subsidiaryService: SubsidiaryService) {
        this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            this.grSubs = this.roleService.getRole(this.id).subscribe(roleObj => {
                this.grSubs.unsubscribe();

                this.gsSubs = this.subsidiaryService.getSubsidiary(roleObj.subsidiaryId).subscribe(subsidiaryObj => {
                    this.gsSubs.unsubscribe();

                    this.role = roleObj;

                    this.role.subsidiaryName = subsidiaryObj.name;
                });
            });

            
        });
    }

    ngOnInit() {

    }

}
